export enum Action {
  Gerenciar = "M",
  Criar = "C",
  Ler = "R",
  Atualizar = "U",
  Deletar = "D",
}
